import InventoryList from '../../../components/Main/Stock/InventoryList'
import StockList from '../../../components/Main/Stock/StockList'
import StockModal from '../../../components/Main/Stock/StockModal'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Modal, Row, Tabs } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function Stock(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Stock Management /</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Stock Management'}
              subtitle={'Manage Stock information and prices.'}
              color={'#FF6138'}
              iconType={'shopping-cart'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <StockModal {...props} />
            <Tabs>
              <Tabs.TabPane tab="Inventory" key="1">
                <InventoryList {...props} />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Stock" key="2">
                <StockList {...props} />
              </Tabs.TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Stock.propTypes = {}
Stock.defaultProps = {}

export default Stock
